export const MENU_MESSAGES = {
  GETTING_STARTED: "Getting Started",
  CALENDAR: "Calendar",
  LIVE_WORKER_ETA: "Live Worker ETA",
  FACILITY_RULES_AI: "Workplace Rules Quiz",
  WORKERS: "Professionals",
  BROWSE_PROFESSIONALS: "Browse Professionals",
  PLACEMENT_SECTION: "Permanent Hiring",
  HIRE_PROFESSIONALS: "Browse Talent Pool",
  MANAGE_JOBS: "Applications & Jobs",
  INTERVIEW_SCHEDULE: "Interview Schedule",
  MANAGE_JOB_APPLICATIONS: "Manage Applications",
  INTERVIEW_SETTINGS: "Interview Availability",
  PAY_TRANSPARENCY: "Pay Transparency",
  REPORTING: "Reporting",
  CHAT: "Chat",
  MANAGEMENT: "Management",
  MY_ACCOUNT: "My Account",
  TEAM_MEMBERS: "Team Members",
  USERS: "Users",
  FACILITY_INFORMATION: "Workplace Information",
  REQUIRED_DOCUMENTS: "Workplace Requirements",
  SETTINGS: "Settings",
  REFER_AND_EARN: "Refer & Earn",
  BILLING: "Billing",
  UPCOMING_CHARGES: "Upcoming Charges",
  INVOICE_HISTORY: "Invoice History",
  CONTRACT_TERMS: "Contract Terms",
  HELP_CENTER: "Help Center",
  USER_PROFILE: "User Profile",
  MY_PROFESSIONALS: "My Professionals",
  JOBS_LANDING_PAGE: "Landing Page",
  CHARTING: "Charting",
  PLACEMENT: "Placement",
  CANDIDATE_PROFILE: "Candidate Profile",
  EXCLUSIONS: "Exclusions",
  CORPORATE_CENTER: "Corporate Center",
  CORPORATE_ANALYTICS: "Corporate Analytics",
  SPENDING_CONTROLS: "Spend Controls",
};

export const supportTicketUrl = "https://support.clipboardhealth.com/hc/en-us/requests/new";
